<template>
  <div class="col-md-12 reports_list">
    <div class="header">
      <fg-input v-model="filter.name" :placeholder="translate('reports.name')" :clearable="true" @input="change_filter" />
      <button class="btn btn-info btn-fill" @click="load_reports">{{ translate('reports.refresh') }}</button>
    </div>
    <div class="response_table">
      <scale-loader v-if="loading" />
      <table v-else>
        <thead>
          <tr>
            <th class="w5per">ID</th>
            <th class="text-left">{{ translate('reports.name') }}</th>
            <th class="w15per">{{ translate('reports.metric') }}</th>
            <th class="w15per">{{ translate('reports.status') }}</th>
            <th class="w10per text-left">{{ translate('reports.client_name') }}</th>
            <th class="w10per text-left">{{ translate('reports.owner_user_name') }}</th>
            <th class="w10per">{{ translate('reports.created_at') }}</th>
            <th class="w10per">{{ translate('reports.started_at') }}</th>
            <th class="w10per">{{ translate('reports.finished_at') }}</th>
          </tr>
        </thead>
        <tbody>
          <ReportListItem v-for="report in reports" :key="report.id" :report="report" />
          <tr v-if="!reports.length"><td>{{ translate('no_data') }}</td></tr>
        </tbody>
      </table>
    </div>
    <div class="pagination-buttons">
      <button class="btn btn-info btn-fill" :disabled="loading || offset === 0" @click="change_page(-1)">{{ translate('reports.previous') }}</button>
      <span>{{ offset / limit + 1 }}</span>
      <button class="btn btn-info btn-fill" :disabled="loading || reports.length < limit" @click="change_page(1)">{{ translate('reports.next') }}</button>
    </div>
  </div>
</template>
<script>
import ReportListItem from './Item/Index.vue'

export default {
  name: 'ReportList',
  components: { ReportListItem },
  data() {
    return { reports: [], filter: { name: '' }, offset: 0, limit: 20, loading: false, timer: null, request_id: 0 }
  },
  activated() { this.load_reports() },
  deactivated() {
    clearTimeout(this.timer)
    this.request_id++
  },
  beforeDestroy() { clearTimeout(this.timer) },
  methods: {
    change_filter() {
      clearTimeout(this.timer)
      this.offset = 0
      this.timer = setTimeout(this.load_reports, 500)
    },
    change_page(direction) {
      this.offset += direction * this.limit
      this.load_reports()
    },
    load_reports() {
      clearTimeout(this.timer)
      const request_id = ++this.request_id
      this.loading = true
      this.$http.v1.getReports({ ...this.filter, limit: this.limit, offset: this.offset }, (response) => {
        if (request_id !== this.request_id) return
        this.reports = response.data || []
      }).finally(() => {
        if (request_id === this.request_id) this.loading = false
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.reports_list {
  height: 100%;
  display: flex;
  flex-direction: column;
  .header { display: flex; align-items: center; gap: 10px; padding-top: 10px; }
  .header .form-group { flex: 1; margin-bottom: 0; }
  .response_table { padding-left: 0; padding-right: 0; }
  th.text-left { text-align: left; }
  .pagination-buttons { display: flex; justify-content: center; align-items: center; gap: 10px; padding: 10px 0; }
}
</style>
